import { MessageBarType, MessageBar, PrimaryButton, Icon } from '@fluentui/react';
import React, { FC, useState, useEffect } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { ApiException, Dialog, TextField } from '@eta/components';
import { isNull } from 'util';
import { ReduxState } from '../../common/reducers';
import {
    LanguageTypes,
    ProfileType,
    ResendUserOTPRequest,
    ValidateTaxpayerOtpRequest,
    ValidationType,
} from '../../Services/ClientProxy/clientProxy';
import { otpVerifyUser, otpVerifyTaxpayer } from '../Redux/Actions';

import './EmailMobile.scss';
import { isEmptyText } from '../../helpers/utils';
import { Defaults } from '../../common/config/constants';
import { validateContactDetails } from '../../ProviderManagement/Redux/Actions';
import { ContactTypes } from '../../ProviderManagement/Service/proxy';
import { ServiceCreator } from '../../Services/ClientProxy/ServiceFactory';

const mapStateToProps = (state: ReduxState) => ({
    lastError: state.Verify.lastError,
});

const mapDispatchToProps = {
    verify: otpVerifyUser,
    verifyTaxpayer: otpVerifyTaxpayer,
    verifyIntermediaryOTP: validateContactDetails
};

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;
export interface Props {
    NewMobile?: string;
    NewEmail?: string;
    hidden: boolean;
    onClose: () => void;
    onSave: () => void;
    Type: string;
    verifyIntermediary?: boolean;
    taxpayerId?: number;
    preferredLanguage?: LanguageTypes | undefined;
}

const EmailMobile: FC<PropsFromRedux & Props> = (
    props: PropsFromRedux & Props
) => {
    const {
        NewMobile,
        NewEmail,
        hidden,
        onClose,
        verify,
        onSave,
        verifyTaxpayer,
        Type,
        lastError,
        verifyIntermediary,
        verifyIntermediaryOTP,
        taxpayerId,
        preferredLanguage
    } = props;

    const { t } = useTranslation([
        'resources',
        'common',
        'myProfile',
        'validation',
    ]);
    const [mobileCode, setmobileCode] = useState<string>();
    const [emailcode, setemailcode] = useState<string>('');
    const [step, setstep] = useState<string>('Email');
    const [mobile, setmobile] = useState<string>();
    const [email, setemail] = useState<string>();
    const [showMessageSuccess, setShowMessageSuccess] = useState<boolean>(
        false
    );
    const [error, setError] = useState<string>();
    const [seconds, setSeconds] = useState<number>(Defaults.ResendOTP);
    const [resendEmailOtp, setResendEmailOtp] = useState<boolean>(false);
    const [reSetTimer, setReSetTimer] = useState<boolean>(false);
    
    
    useEffect(() => {
        if (NewMobile !== '' && NewEmail !== '') {
            setmobile(NewMobile);
            setemail(NewEmail);
        }
    }, [NewMobile, NewEmail]);

    useEffect(() => {

        if (lastError) {
            setShowMessageSuccess(false);
            setError(lastError?.serviceError?.toString());
        }
    }, [lastError]);

    const handleContinue = async () => {

        let response;

        if (verifyIntermediary) {
            response = await verifyIntermediaryOTP(taxpayerId || 0, emailcode, ContactTypes.Email);
        } else {
            const body = new ValidateTaxpayerOtpRequest({
                validationType: ValidationType.Email,
            });
            if (Type === 'User') {
                response = await verify(body, emailcode);
            } else {
                response = await verifyTaxpayer(body, emailcode);
            }
        }

        if (isNull((await response.payload).lastError)) {
            setstep('Mobile');
            if(resendEmailOtp){
                setReSetTimer(true);
            }
            setError('');
            setShowMessageSuccess(true);
            setTimeout(() => {
                setShowMessageSuccess(false);
            }, Defaults.AutoDismissPeriod);
        }
    };

    const handleVerifyClick = async () => {
        let response;
        if (verifyIntermediary) {
            response = await verifyIntermediaryOTP(taxpayerId || 0, mobileCode || '', ContactTypes.Mobile);
        } else {

            const body = new ValidateTaxpayerOtpRequest({
                validationType: ValidationType.Mobile,
            });
            if (Type === 'User') {
                response = await verify(body, mobileCode);
            } else {
                response = await verifyTaxpayer(body, mobileCode);
            }
        }
        if (isNull((await response.payload).lastError)) {
            onSave();
        }
    };

    useEffect(() => {
        if (!hidden) {
            setstep('Email');
            setError('');
            setShowMessageSuccess(false);
            setemailcode('');
            setemailcode('');
        }
    }, [hidden]);

    const renderTimer = (time: number) => {
        let second = (time % 60).toString();
        let minute = (Math.floor(time / 60)).toString();
        minute = minute.toString().length === 1 ? `0${minute}` : minute.toString();
        second = second.toString().length === 1 ? `0${second}` : second.toString();
        return `${minute}:${second}`;
    };

    useEffect(() => {
        if (seconds > 0) {
            setTimeout(() => setSeconds(reSetTimer ? 0 : (seconds - 1)), 1000);
        }
    });

    const resendOTP = async (type: ValidationType) => {
        try {
            const client = ServiceCreator.getTaxPayerProfileManagementClient(false);
            const response = await client.resendUserOtp(
                new ResendUserOTPRequest({
                    preferredLanguage: preferredLanguage ?? LanguageTypes.None,
                    profileType: (Type === 'User') ? ProfileType.TaxpayerRepresentative : ProfileType.TaxPayer,
                    validationType: type,
                })
            );
            if (response) {
                if(type === ValidationType.Mobile){
                    setReSetTimer(false);
                }
                setResendEmailOtp(true);
                setSeconds(Defaults.ResendOTP);
            }
        } catch (ex) {
            const exception = ex as ApiException;
            setError(exception.serviceError?.toString());
        }
    };

    return (
        <Dialog
            hidden={hidden}
            onDismiss={() => {
                onClose();
            }}
            maxWidth={450}
            title=""
        >
            <div className="Verify">
                {step === 'Email' ? (
                    <div className="verifyEmailMob">
                        <Icon iconName="MailCheck" /> {t('EmailVerification')}
                        {error && (
                            <MessageBar
                                messageBarType={MessageBarType.error}
                                isMultiline={false}
                                onDismiss={() => setError('')}

                            >
                                {error}
                            </MessageBar>
                        )}
                        <div className="bodyLine">
                            <p className="headerEmailMob">
                                {t('form.verification.sentToMail')}
                                <br />
                                <strong>{email}</strong>
                                {t('form.verification.sentToMail2')}
                            </p>
                        </div>
                        <div className="bodyLine">
                            <p className="alert">
                                {t('form.verification.emailAlert')}
                            </p>
                        </div>
                        <div className="bodyLine ClientDetails">
                            <TextField
                                maxLength={6}
                                autoFocus
                                onChange={(_, v) => setemailcode(v ?? '')}
                                value={emailcode}
                                placeholder={t(
                                    'form.verification.verificationCode'
                                )}
                            />
                        </div>
                        <div>
                            <div className='resend'>
                                <span> {t('receive_Email')} </span>
                                {seconds > 0 ? (
                                    <div className='inline_Content'>
                                        <span> {t('resend_code')} </span>
                                        <span className='font_Timer'> {renderTimer(seconds)} </span>
                                    </div>

                                ) : (
                                        // eslint-disable-next-line jsx-a11y/anchor-is-valid
                                        <a href={undefined} className='Link_Button' onClick={() => resendOTP(ValidationType.Email)}> {t('resend')} </a>
                                    )}
                            </div>
                        </div>
                    </div>
                ) : (
                        <div className="verifyEmailMob">
                            <Icon iconName="MobileSelected" /> {t('MobileVerification')}
                            {showMessageSuccess && (
                                <MessageBar
                                    messageBarType={MessageBarType.success}
                                    isMultiline={false}
                                    onDismiss={() => setShowMessageSuccess(false)}

                                >
                                    {t('myProfile:successSaved')}
                                </MessageBar>
                            )}

                            {error && (
                                <MessageBar
                                    messageBarType={MessageBarType.error}
                                    isMultiline={false}
                                    onDismiss={() => setError('')}

                                >
                                    {error}
                                </MessageBar>
                            )}
                            <div className="bodyLine">
                                <p className="headerEmailMob">
                                    {t('form.verification.sentToMobile')}
                                    <br />
                                    <strong>{mobile}</strong>
                                    {t('form.verification.sentToMobile2')}
                                </p>
                            </div>
                            <div className="bodyLine ClientDetails">
                                <TextField
                                    maxLength={6}
                                    autoFocus
                                    onChange={(_, v) => setmobileCode(v ?? '')}
                                    value={mobileCode}
                                    placeholder={t(
                                        'form.verification.verificationCode'
                                    )}
                                />
                            </div>
                            <div>
                                <div className='resend'>
                                    <span> {t('receive_SMS')} </span>
                                    {seconds > 0 ? (
                                        <div className='inline_Content'>
                                            <span> {t('resend_code')} </span>
                                            <span className='font_Timer'> {renderTimer(seconds)} </span>
                                        </div>

                                    ) : (
                                            // eslint-disable-next-line jsx-a11y/anchor-is-valid
                                            <a href={undefined} className='Link_Button' onClick={() => resendOTP(ValidationType.Mobile)}> {t('resend')} </a>
                                        )}
                                </div>
                            </div>
                        </div>
                    )}
                <div className="bodyLine doneBtn">
                    <div className="alignEnd">
                        {step === 'Email' ? (
                            <PrimaryButton
                                text={t('form-components.continue')}
                                onClick={() => handleContinue()}
                                disabled={isEmptyText(emailcode)}

                            />


                        ) : (
                                <PrimaryButton
                                    text={t('form-components.verify')}
                                    onClick={() => handleVerifyClick()}
                                    disabled={isEmptyText(mobileCode)}

                                />



                            )}
                    </div>
                </div>
            </div>
        </Dialog>
    );
};

export default connector(EmailMobile);
